// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keypad-container-box{
  display: flex;
  flex: 1;
  min-width: 200px;
  margin-left: 0.7rem;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/keypad/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".keypad-container-box{\n  display: flex;\n  flex: 1;\n  min-width: 200px;\n  margin-left: 0.7rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
